/* KRIMA: one automatic matcha gift from $140,000 COP before discounts. */
(function () {
  'use strict';
  const gift = window.krimaComboGift;
  if (!gift || !gift.giftVariantId) return;
  const root = gift.root || '/';
  const marker = '_krima_threshold_gift';
  const markerValue = 'matcha-120000-v1';
  const request = window.fetch.bind(window);
  let timer, checking = false, checkAgain = false;
  function scheduleCheck() {
    clearTimeout(timer);
    timer = setTimeout(checkCart, 250);
  }
  function isAutomatic(item) {
    return item.properties && item.properties[marker] === markerValue;
  }
  async function post(path, body) {
    const response = await request(root + path, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
    if (!response.ok) throw new Error('No se pudo actualizar el regalo (' + response.status + ')');
  }
  async function checkCart() {
    if (checking) { checkAgain = true; return; }
    checking = true;
    try {
      const response = await request(root + 'cart.js', {
        credentials: 'same-origin', cache: 'no-store'
      });
      if (!response.ok) throw new Error('No se pudo consultar el carrito');
      const cart = await response.json();
      const automatic = cart.items.filter(isAutomatic);
      const subtotal = cart.items.reduce(function (sum, item) {
        if (isAutomatic(item) || item.gift_card) return sum;
        return sum + Number(item.original_line_price || 0);
      }, 0);
      const eligible = cart.currency === gift.currency && subtotal >= gift.threshold;
      const current = automatic.find(item => Number(item.variant_id) === Number(gift.giftVariantId));
      const updates = {};
      automatic.forEach(function (item) {
        const quantity = eligible && item === current ? 1 : 0;
        if (item.quantity !== quantity) updates[item.key] = quantity;
      });
      let changed = false;
      if (Object.keys(updates).length) {
        await post('cart/update.js', { updates: updates });
        changed = true;
      }
      try {
        if (eligible && !current && gift.giftAvailable) {
          await post('cart/add.js', { items: [{
            id: gift.giftVariantId, quantity: 1,
            properties: { [marker]: markerValue }
          }] });
          changed = true;
        }
      } finally {
        if (changed) document.dispatchEvent(new CustomEvent('theme:update:cart'));
      }
    } catch (error) {
      console.warn('[Krima] Regalo automático:', error);
    } finally {
      checking = false;
      if (checkAgain) { checkAgain = false; scheduleCheck(); }
    }
  }
  function isCartMutation(url) {
    try {
      const path = new URL(url, window.location.href).pathname;
      return /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(path);
    } catch (_) { return false; }
  }
  // Observe the existing combo guard and app requests without altering their bodies.
  window.fetch = function (input, options) {
    const url = typeof input === 'string' ? input : input && (input.url || input.href);
    return request(input, options).then(function (response) {
      if (response.ok && isCartMutation(url)) scheduleCheck();
      return response;
    });
  };
  const xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._krimaGiftMutation = isCartMutation(url);
    return xhrOpen.apply(this, arguments);
  };
  const xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this._krimaGiftMutation) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) scheduleCheck();
      }, { once: true });
    }
    return xhrSend.apply(this, arguments);
  };
  ['shapes:cart:afteradditem', 'theme:line-item:change', 'theme:cart:change',
    'cart:updated', 'theme:cart-drawer:open'].forEach(function (event) {
    document.addEventListener(event, scheduleCheck);
  });
  window.addEventListener('pageshow', scheduleCheck);
  scheduleCheck();
})();
